import React, { useEffect, useState } from "react"
import { Button } from "reactstrap"
import { get } from "helpers/api_helper"
import { describeChange, when } from "./catalogHistory"

const PAGE_SIZE = 10

// The catalog's change history, after System Settings' MaintenanceHistory: pages of 10, newest first, Refresh. `refresh`
// changes when a change is saved, `themes` (the catalog read) names the theme of a changed reason.
export default function ChangeHistory({ refresh, themes }) {
  const [page, setPage] = useState(1), [retry, setRetry] = useState(0), [read, setRead] = useState({ loading: true })
  useEffect(() => {
    let current = true
    setRead({ loading: true })
    get(`/admin/tournament-feedback/catalog/history?page=${page}`).then(response => {
      const data = response?.data
      if (!Array.isArray(data?.items) || !Number.isSafeInteger(data.totalResults)) throw new Error("Invalid history")
      if (current) setRead({ data })
    }).catch(() => { if (current) setRead({ error: true }) })
    return () => { current = false }
  }, [page, refresh, retry])
  const again = () => setRetry(value => value + 1)
  const pages = read.data ? Math.max(page, Math.ceil(read.data.totalResults / PAGE_SIZE)) : 1
  return <section aria-label="Change history">
    <div className="feedback-setup__heading mb-2"><h5 className="mb-0">Change history</h5>
      <Button size="sm" disabled={read.loading} onClick={again}>Refresh</Button></div>
    <p className="small text-muted">Every change of the themes and reasons, newest first. Each one is also in the activity logs.</p>
    {read.loading && <p role="status" className="text-muted">Loading the change history…</p>}
    {read.error && <p role="alert" className="text-danger">The change history could not be loaded.{" "}
      <Button color="link" className="p-0 align-baseline" onClick={again}>Retry</Button></p>}
    {read.data && <>
      {!read.data.items.length && <p className="text-muted mb-0">No changes have been recorded yet.</p>}
      {read.data.items.map(entry => {
        const { actor, title, detail } = describeChange(entry, themes)
        return <article key={entry.version} className="feedback-setup__history">
          <div className="feedback-setup__history-head"><strong data-history>{actor}</strong><span data-history className="text-muted">{when(entry.at)}</span></div>
          <div data-history className="font-weight-medium">{title}</div>
          <div data-history className="small">{detail}</div>
          <details className="small text-muted mt-1"><summary>Technical details</summary>
            <div>Version {entry.version}</div>{entry.operationId && <div>Request: {entry.operationId}</div>}</details>
        </article>
      })}
      {pages > 1 && <div className="feedback-setup__pages">
        <Button size="sm" disabled={page <= 1} onClick={() => setPage(value => value - 1)}>Previous</Button>
        <span>Page {page} of {pages}</span>
        <Button size="sm" disabled={page * PAGE_SIZE >= read.data.totalResults} onClick={() => setPage(value => value + 1)}>Next</Button>
      </div>}
    </>}
  </section>
}
